import sentry from '@/services/sentry'

/**
 * Calculate billing cycle number from billing_cycle_anchor
 * @param {number|string} billingCycleAnchor - Timestamp in milliseconds (e.g., 1759293134000)
 * @param {Date} [now=new Date()] - Current date for calculation (injectable for testing)
 * @returns {number|null} - Billing cycle number as number, or null if invalid
 */
export const calculateBillingCycleNumber = (billingCycleAnchor, now = new Date()) => {
  try {
    if (!billingCycleAnchor) return null

    const anchorDate = new Date(billingCycleAnchor)
    const currentDate = now

    // Validate dates
    if (Number.isNaN(anchorDate.getTime()) || Number.isNaN(currentDate.getTime())) {
      return null
    }

    // Calculate the difference in months
    const yearDiff = currentDate.getFullYear() - anchorDate.getFullYear()
    const monthDiff = currentDate.getMonth() - anchorDate.getMonth()

    let totalMonths = yearDiff * 12 + monthDiff

    if (currentDate.getDate() < anchorDate.getDate()) {
      totalMonths -= 1
    }

    return Math.max(0, totalMonths) + 1
  } catch (error) {
    sentry.captureException(error, {
      extra: {
        billingCycleAnchor,
        action: 'calculateBillingCycleNumber',
      },
    })
    return null
  }
}

export default {
  calculateBillingCycleNumber,
}
